/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Right_Center_Justify_Right_PosInputs */



/**
* | output |
* | --- |
* | "Center Justify / Right Position" |
*
* @param {Align_Right_Center_Justify_Right_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_right_center_justify_right_pos = /** @type {((inputs?: Align_Right_Center_Justify_Right_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Right_Center_Justify_Right_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Justification Centree / Position Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zentriert / Rechtsposition")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allineamento al centro / Posizione a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центрирование / Выравнивание по правому краю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Justificación centrada / Posición derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("居中对齐/右对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央揃え / 右揃え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र संरेखित करें / दाईं ओर स्थित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centralizado / Posicionamento à direita")
	return /** @type {LocalizedString} */ ("Center Justify / Right Position")
});